import React, { useState, useRef, useEffect, forwardRef } from "react";
// import Info from "../assets/icons/ic_info.svg";

// const MultiSelectWithAdd = ({
const MultiSelectWithAdd = forwardRef(
  (
    {
      name,
      options = [],
      value = "",
      onChange,
      setIsEdited,
      placeHolder,
      label = "",
      error,
    },
    ref
  ) => {
    const [input, setInput] = useState("");
    const [selected, setSelected] = useState(
      value ? value.split(",").map((v) => v.trim()) : []
    );
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    // Expose the real input to parent via ref
    useEffect(() => {
      if (ref) {
        ref.current = wrapperRef.current; // 👈 parent now can use it like a normal ref
      }
    }, [ref]);

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (!wrapperRef.current.contains(e.target)) {
          setShowDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
      setSelected(value ? value.split(",").map((v) => v.trim()) : []);
    }, [value]);

    const filteredOptions = options.filter(
      (opt) =>
        opt.toLowerCase().includes(input.toLowerCase()) &&
        !selected.includes(opt)
    );

    const addItem = (item) => {
      if (!selected.includes(item)) {
        const updated = [...selected, item];
        setSelected(updated);
        onChange({ target: { name: name, value: updated.join(", ") } });
      }
      setInput("");
      if (name === "medicalIssues") setIsEdited(true);
      setShowDropdown(false);
    };

    const removeItem = (item) => {
      const updated = selected.filter((i) => i !== item);
      setSelected(updated);
      onChange({ target: { name: name, value: updated.join(", ") } });
    };

    return (
      <div ref={wrapperRef} style={{ width: "100%", position: "relative" }}>
        <label className="block text-inputColor text-sm font-normal mb-1">
          {label}
        </label>
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: 4,
            padding: 6,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 6,
            minHeight: 40,
            cursor: "text",
          }}
          onClick={() => setShowDropdown(true)}
        >
          {selected.map((item) => (
            <span
              key={item}
              style={{
                backgroundColor: "#e3f2fd",
                padding: "4px 8px",
                borderRadius: 12,
                display: "flex",
                alignItems: "center",
              }}
            >
              {item}
              <span
                style={{ marginLeft: 6, cursor: "pointer", fontWeight: "bold" }}
                onClick={(e) => {
                  e.stopPropagation();
                  removeItem(item);
                }}
              >
                ×
              </span>
            </span>
          ))}

          <input
            ref={ref} // 👈 actual input reference if parent wants the input itself
            className="text-sm placeholder-gray-400 pl-1"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setShowDropdown(true);
            }}
            placeholder={placeHolder}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
              minWidth: 100,
            }}
          />
        </div>

        {/* {error && (
        <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
          <img src={Info} alt="info" />
          {error}
        </div>
      )} */}

        {showDropdown && (filteredOptions.length > 0 || input.trim()) && (
          <ul
            style={{
              position: "absolute",
              width: "100%",
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: 4,
              marginTop: 2,
              maxHeight: 200,
              overflowY: "auto",
              listStyle: "none",
              padding: 0,
              zIndex: 999,
            }}
          >
            {input.trim() &&
              !options.some((o) => o.toLowerCase() === input.toLowerCase()) && (
                <li
                  className="text-xs"
                  onClick={() => addItem(input.trim())}
                  style={{
                    padding: 8,
                    cursor: "pointer",
                    background: "#f0f0f0",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  Add "{input.trim()}"
                </li>
              )}
            {filteredOptions.map((opt, i) => (
              <li
                className="text-xs"
                key={i}
                onClick={() => addItem(opt)}
                style={{
                  padding: 8,
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
              >
                {opt}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
);

export default MultiSelectWithAdd;
